import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { Form, FormListFieldData } from 'antd';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import ReoderBookingSortableItem from './ReoderBookingSortableItem';
import styled from 'styled-components';
import { IReoderListItemType } from './ReoderBooking';

type ReoderBookingFormProps = {
  fields: FormListFieldData[];
  move: (from: number, to: number) => void;
};

const ReoderBookingForm = ({ fields, move }: ReoderBookingFormProps) => {
  const form = Form.useFormInstance();
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const items = (Form.useWatch('items', form) as IReoderListItemType[]) || [];
  const ids = items.map((o) => String(o.id));

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={({ active, over }) => {
        if (!over) return;
        const oldIndex = ids.indexOf(String(active.id));
        const newIndex = ids.indexOf(String(over.id));
        if (oldIndex !== -1 && newIndex !== -1 && oldIndex !== newIndex) move(oldIndex, newIndex);
      }}
    >
      <SortableContext items={ids} strategy={verticalListSortingStrategy}>
        <ListContainer>
          {fields.map((field) => {
            const id = form.getFieldValue(['items', field.name, 'id']);
            const name = form.getFieldValue(['items', field.name, 'name']);
            const type = form.getFieldValue(['items', field.name, 'type']);
            const avatar = form.getFieldValue(['items', field.name, 'avatar']);
            return (
              <ReoderBookingSortableItem
                key={id}
                id={id}
                name={name}
                type={type}
                field={field}
                avatar={avatar}
              />
            );
          })}
        </ListContainer>
      </SortableContext>
    </DndContext>
  );
};

export default ReoderBookingForm;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 60vh;
  overflow-y: auto;
  padding: 16px;
`;
